import { render } from "./SpmEmptyState.vue?vue&type=template&id=2927ff74&scoped=true"
import script from "./SpmEmptyState.vue?vue&type=script&lang=ts"
export * from "./SpmEmptyState.vue?vue&type=script&lang=ts"

import "./SpmEmptyState.vue?vue&type=style&index=0&id=2927ff74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2927ff74"

export default script